<div id="main-content">
  <lib-pegase-header id="app-header" [title]="appTitle" icon="upload_file">
    <lib-authentication-form />
  </lib-pegase-header>

  <main id="top">
    <div id="content">
      <router-outlet />
    </div>
  </main>
  <lib-pegase-footer version="{{ version }}"></lib-pegase-footer>
</div>
